<template>
  <div id="app">
    <div class="wrapper">
      <!-- Content -->
      <div id="content" class="content">
        <div class="row justify-content-center align-items-center login-top">
          <div class="col-lg-3 p-0 d-none d-lg-block">
            <div class="log-pic">
              <img src="../../assets/images/login.jpg" alt />
            </div>
          </div>
          <div class="col-lg-3 p-lg-0">
            <div class="login">
              <img class="log-logo" src="../../assets/images/logo.png" alt />
              <div class="log-text">
                Preencha as informações para realizar login no Pesquisa.
              </div>
              <form @submit.prevent="login">
                <div class="form-group">
                  <label for="inputEmail">Email</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="user.email"
                  />
                </div>
                <div class="form-group">
                  <label for="inputSenha">Senha</label>
                  <input
                    type="password"
                    class="form-control"
                    v-model="user.password"
                  />
                </div>
                <button type="submit" class="btn btn-block btn-login">
                  Entrar
                </button>
                <div class="text-center mt-3">
                  <a href="#" data-toggle="modal" data-target="#modalSenha">Esqueci minha senha</a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer id="footer" class="footer">
      <div class="copyright">
        <p class="left small">InnovareTI 2019</p>
        <p class="right small">
          Desenvolvido por
          <a href="https://www.innovareti.com.br/" target="_blank">
            <img src="../../assets/images/logo-innovare-dark.png" alt="Logo" />
          </a>
        </p>
      </div>
    </footer>
    <!-- Modal -->
    <div
      class="modal fade"
      id="modalSenha"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalSenhaTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalSenhaTitle">
              Esqueci minha senha
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="log-text">
              Insira seu email cadastrado e em instantes você receberá uma nova
              senha.
            </div>
            <form action>
              <div class="form-group">
                <input
                  type="email"
                  class="form-control"
                  id="inputEmailPass"
                  placeholder="Email"
                  value="admin@innovareti.com.br"
                />
              </div>
              <a
                href
                type="button"
                class="btn btn-block btn-login"
                data-dismiss="modal"
                aria-label="Close"
                >Enviar nova senha</a
              >
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: {
        email: "",
        password: "",
      },
    };
  },
  methods: {
    login() {
      const self = this;
      const api = this.$store.state.api + "login";

      axios
        .post(api, {
          email: self.user.email,
          password: self.user.password,
        })
        .then((response) => {
          self.$store.commit("auth", {
            token: response.data.access_token,
            type_id: response.data.type_id,
            trial: response.data.trial,
          });

          if (response.data.type_id == 1) {
            if (response.data.researchFirstStep) {
              self.$router.push(response.data.researchFirstStep);
            } else {
              self.$router.push({ path: "/" });
            }
          } else if (response.data.type_id == 2) {
            self.$router.push({ path: "/worker" });
          } else if (response.data.type_id == 3) {
            self.$router.push({ path: "/worker" });
          } else if (response.data.type_id == 4) {
            self.$router.push({ path: "/requestAccess" });
          }
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
  },
};
</script>

<style scoped>
body {
  font-family: "Roboto", sans-serif;
}
form .form-input {
  width: 90% !important;
  font-size: 15px !important;
  padding: 10px !important;
  border: 1px solid #c0c0c0;
}
form .form-label {
  width: 90% !important;
  display: block;
  text-align: left;
  font-size: 16px !important;
  margin-left: auto;
  margin-right: auto;
}
form .form-button {
  width: 90%;
  padding: 10px;
  font-size: 18px;
  border-radius: 30px;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid #f0f0f0;
  background: #1197d6 !important;
  color: white;
}

#myModal {
  text-align: left;
}

@media (max-width: 768px) {
  .ibox {
    margin: 0px 0px 0px 0px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Auth/LoginEmail.vue